import { formatPercent } from '@/lib/utils'

export const REPORT_PIE_CHART_COLORS = [
  'var(--color-chart-1)',
  'var(--color-chart-2)',
  'var(--color-chart-3)',
  'var(--color-chart-4)',
  'var(--color-chart-5)',
  'var(--color-success)',
  'var(--color-info)',
  'var(--color-warning)',
]

export function formatPieSharePercent(share: unknown) {
  if (typeof share !== 'number' || !Number.isFinite(share)) {
    return formatPercent(0, 0)
  }

  const percentage = share * 100
  const hasWholePercentage = Math.abs(percentage - Math.round(percentage)) < 0.000001

  return formatPercent(share, hasWholePercentage ? 0 : 1)
}
